import firebase from 'firebase'
import {
  identifyUserToAnalytics,
  resetAnalytics
} from "services/browser/Analytics";
import { loginAtSubdomain } from 'services/browser/SubdomainLogin';
import { logoutAtSubdomain } from 'services/browser/SubdomainLogout';

function useWhenLoggingInOrOut() {

    async function whenLoggingInOrOut(user: firebase.User) {
        if (user) {
            await loginAtSubdomain(user)
            await identifyUserToAnalytics(
              user.uid,
              user.email
            );
        } else {
            await logoutAtSubdomain()
            resetAnalytics();
        }
        
    }

    return whenLoggingInOrOut;
}

export default useWhenLoggingInOrOut;